<template>
  <div :style="{ width, height }"></div>
</template>

<script>
import amapLoader from './amap'

export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    d3: {
      type: Boolean,
      default: true
    }, // 是否显示 3D
    d3Features: {
      type: Array,
      default() {
        return ['bg']
      }
    },
    bounds: {
      type: Array,
      default() {
        return []
      }
    },
    zoom: {
      type: [Number, String]
    },
    center: Array
  },
  data() {
    return {
      loading: true,
      Amap: null,
      map: null,
      markers: []
    }
  },
  created() {
    this.loadAMap()
  },
  methods: {
    async loadAMap() {
      this.loading = true
      this.AMap = await amapLoader()

      let opts = {}
      if (this.bounds[0]) {
        opts = {
          mask: this.bounds,
          viewMode: '3D',
          pitch: 15
        }
      }

      this.map = new this.AMap.Map(this.$el, opts)

      this.AMap.plugin(['AMap.TileLayer'], () => {
        this.setSatellite()
      })

      if (this.bounds[0]) {
        this.setGeo(this.bounds)
      }

      this.loading = false
      this.switchLayer()
      this.$emit('complete', this.map, this.AMap)
    },
    getMarker(points) {
      points = Array.isArray(points) ? points : [points]

      return points.map(({ lng, lat, content, title, icon, offset, info }) => {
        const options = { position: new this.AMap.LngLat(lng, lat), title }
        if (icon) options.icon = icon
        if (content) options.content = content
        if (offset) options.offset = new this.AMap.Pixel(offset, offset)
        if (title) options.title = title

        const marker = new this.AMap.Marker(options)

        if (info) {
          const position = marker.getPosition()
          marker.on('mouseover', () => {
            this.infoWindow = new this.AMap.InfoWindow({
              isCustom: true,
              content: info,
              offset: new this.AMap.Pixel(6, -30)
            })
            this.infoWindow.open(this.map, position)
          })
          marker.on('mouseout', () => {
            this.map.clearInfoWindow()
          })
        }

        return marker
      })
    },
    async setMarkers(points) {
      if (!this.AMap) await this.loadAMap()

      this.markers.forEach(m => this.map.remove(m))
      this.$nextTick(() => {
        this.markers = this.getMarker(points)
        this.map.add(this.markers)
        let zoom = this.zoom
        let center = this.center

        if (points.length > 1) {
          this.map.setFitView()
        } else {
          zoom = 14
          center = new this.AMap.LngLat(points[0].lng, points[0].lat)
        }

        if (zoom && center && center[0]) {
          this.map.setZoom(zoom)
          this.map.setCenter(center)
        }
      })
    },
    setSatellite() {
      if (this.roadNet) this.map.remove(this.roadNet)
      this.satellite = new this.AMap.TileLayer.Satellite()
      this.map.add([this.satellite])
      let roadNet = new this.AMap.TileLayer.RoadNet()
      this.map.add([roadNet])
      this.map.setFeatures(this.d3Features)
    },
    switchLayer() {
      if (this.d3) {
        this.setSatellite()
      } else {
        this.map.remove(this.satellite)
        this.map.setFeatures(['bg', 'road', 'point'])
      }
    },
    setCenter(params) {
      this.map && this.map.setCenter(params)
    },
    setFocus(index) {
      let els = document.getElementsByClassName(
        'amap-marker amap-marker__small'
      )
      let prev = document.getElementsByClassName(
        'amap-marker amap-marker__small actived'
      )

      if (prev && prev[0]) {
        prev[0].setAttribute('class', 'amap-marker amap-marker__small')
      }

      if (els && els[index]) {
        let parent = els[index].parentNode.parentNode
        parent.setAttribute('class', 'amap-marker actived')
        els[index].setAttribute(
          'class',
          'amap-marker amap-marker__small actived'
        )
      }
    },
    setGeo(bounds) {
      //添加描边
      for (let i = 0; i < bounds.length; i += 1) {
        new this.AMap.Polyline({
          path: bounds[i],
          strokeColor: '#99ffff',
          strokeWeight: 2,
          fillColor: '#000',
          fillOpacity: 0.3,
          map: this.map
        })
      }
    },
    openInfo(info, title, lng, lat) {
      const options = { position: new this.AMap.LngLat(lng, lat), title }
      const marker = new this.AMap.Marker(options)
      const position = marker.getPosition()
      this.infoWindow = new this.AMap.InfoWindow({
        isCustom: true,
        content: info,
        offset: new this.AMap.Pixel(6, -30)
      })
      this.infoWindow.open(this.map, position)
    }
  },
  watch: {
    d3() {
      this.switchLayer()
    }
  }
}
</script>
